import React from 'react'
import 'react-dates/initialize'
import { Helmet } from 'react-helmet'
import { toast } from 'react-toastify'
import PartnerRoutes from 'routes/partners'
import { ThemeProvider } from 'styled-components'
import GlobalStyle from 'styles/global'
import theme from 'styles/theme'

toast.configure()

const Routes = () => {
  return <PartnerRoutes />
}

const Title = () => {
  return <Helmet title='Guigo TV - Parceiros' />
}

const App = () => {
  return (
    <ThemeProvider theme={theme}>
      <GlobalStyle />
      <Title />
      <Routes />
    </ThemeProvider>
  )
}

export default App
